import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Alert, Container } from 'reactstrap'
import { useSelector } from 'react-redux'
import { Skeleton } from 'primereact/skeleton'
import { BI_AUT003Context } from './context'
import GridHeader from './Grid/GridHeader'
import GridBody from './Grid/GridBody'
import GridFooter from './Grid/GridFooter'
import {
  fnGetValueByKey,
  fnGroupRecursiveData,
  fnReplaceParamKeyWithFilteredValue
} from '../../helpers/functions'
import withRouter from '../../components/Common/withRouter'
import { AuthProtectedContext } from '../../Routes/AuthProtectedContext'

/**
 * Template automatizado BI_AUT003
 * @description Esse template está mapeado para receber todos os dados de uma Procedure, e
 * se auto-rederizar. Versão aprimorada do BI_AUT001 com funcionalidades específicas.
 */

const BI_AUT003 = () => {  
  console.log('🤖 %cTransação dinâmica [BI_AUT003]', 'color:green')  
  const { transactionData } = useContext(AuthProtectedContext)

  console.log('transactionData', transactionData);
  
  const data = Array.isArray(transactionData) && transactionData.length > 0 ? transactionData : null  
  
  const { userProfile, isModalPage } = useSelector(state => ({
    userProfile: state.login.user,
    isModalPage: state.Layout.isModalPage
  }))

  const [isLoading, setisLoading] = useState(false)

  const [gridComponents, setgridComponents] = useState({
    HEAD: [],
    HEADER: [],
    BODY: [],
    FOOTER: []
  })
  
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [paramsOnFilter, setParamsOnFilter] = useState([])
  const [triggerOnFilter, setTriggerOnFilter] = useState(false)
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState('')
  const [filteredData, setFilteredData] = useState([])


  useEffect(() => {
    console.log('data', data)

    if (!Array.isArray(data) || data.length === 0) return

    let recursiveTree = fnGroupRecursiveData(data)
    recursiveTree = { ...recursiveTree }
    console.log('recursiveTree', recursiveTree)

    setgridComponents(state => ({
      ...state,
      HEAD: [recursiveTree[0]?.HEAD],
      HEADER: [recursiveTree[1]?.HEADER],
      BODY: [recursiveTree[2]?.BODY],
      FOOTER: [recursiveTree[3]?.FOOTER]
    }))
  }, [data]) 
 
  if (!data)
    return (
      <div className="page-content">
        <Alert color="danger">
          Esta é uma transação automática e configurável (BI_AUT003). Seu carregamento
          depende de uma rotina.
        </Alert>
      </div>
    )

  return (
    <React.Fragment>
      <BI_AUT003Context.Provider
        value={{
          isLoading,
          userProfile,
          gridComponents,
          setisLoading,
          isOpenModal,
          setIsOpenModal,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          fnReplaceParamKeyWithFilteredValue,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          filteredData,
          setFilteredData
        }}
      >
        <div style={{ paddingBottom: isModalPage && '0px'}}  className="page-content p-0">
          <Container fluid={true} className="dataTable-custom-primary p-0">
            {gridComponents.HEADER.length ? (
              <GridHeader context={BI_AUT003Context} />
            ) : (
              <Skeleton className="mb-3" width="100%" height="5rem"></Skeleton>
            )}

            {gridComponents.BODY.length ? (
              <GridBody />
            ) : (
              <Skeleton className="mb-3" width="100%" height="50vh"></Skeleton>
            )}
  
          {!isModalPage && <>
            {gridComponents.FOOTER.length ? (
              <GridFooter />
            ) : (
              <Skeleton className="mb-3" width="100%" height="5rem"></Skeleton>
            )}
          </>}
          
          </Container>
        </div>
      </BI_AUT003Context.Provider>
    </React.Fragment>
  )
}

export default withRouter(BI_AUT003)
